import { lazy } from "react";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeicons/primeicons.css";
// import Home from "./Pages/Home/Home";
// import Contact from "./Pages/Contact/Contact";
// import About from "./Pages/About/About";
// import Service from "./Pages/Service/Service";
// import Team from "./Pages/Team/Team";
import { BrowserRouter, Routes, Route } from "react-router-dom";
const Team = lazy(() => import("./Pages/Team/Team"));
const Service = lazy(() => import("./Pages/Service/Service"));
const About = lazy(() => import("./Pages/About/About"));
const Contact = lazy(() => import("./Pages/Contact/Contact"));
const Home = lazy(() => import("./Pages/Home/Home"));

function App() {
  return (
    <PrimeReactProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/team" element={<Team />} />
        </Routes>
      </BrowserRouter>
    </PrimeReactProvider>
  );
}

export default App;
